<template>
    <div class="sustainable-component wage-emploee-admin">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-employee-admin</div>-->


        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <v-form v-model="valid" ref="adduserform">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <div class="container-fluid p-0">
                                        <div class="row">
                                            <div class="col">
                                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Anställningsnr." v-model="employeeNumber" :rules="[rules.required]" variant="outlined"></v-text-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Förnamn" v-model="firstName" :rules="[rules.required]" variant="outlined"></v-text-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Efternamn" v-model="lastName" :rules="[rules.required]" variant="outlined"></v-text-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="container-fluid p-0">
                                        <div class="row">
                                            <div class="col">
                                                <v-text-field v-bind:disabled="disabled" bg-color="white" type="date" label="Anställningadatum" v-model="employeeStartDate" :rules="[rules.required]" variant="outlined"></v-text-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <v-text-field v-bind:disabled="disabled" bg-color="white" type="date" label="Yrkets startdatum" v-model="occupationStartDate" variant="outlined"></v-text-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Personnummer" :rules="[rules.socialsecurityformat]" v-model="socialSecurityNumber" variant="outlined"></v-text-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="container-fluid p-0">
                                        <div class="row">
                                            <div class="col">
                                                <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container-fluid p-0">
                                        <div class="row">
                                            <div class="col">
                                                <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" label="Kön" :items="sexes" v-model="sex" item-title="name" item-value="value"></v-select>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="container-fluid p-0" v-if="analysisCriterias1.length > 1">
                                        <div class="row">
                                            <div class="col">
                                                <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" v-bind:label="analysisCriteria1Name" :items="analysisCriterias1" v-model="analysisCriteria1"></v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container-fluid p-0" v-if="analysisCriterias2.length > 1">
                                        <div class="row">
                                            <div class="col">
                                                <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" v-bind:label="analysisCriteria2Name" :items="analysisCriterias2" v-model="analysisCriteria2"></v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-5">
                                    <div class="col">
                                        <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addEmployee">
                                            Spara
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col"></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('AnstNr')">Anst.nr.</a></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('Fornamn')">Förnamn</a></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('Efternamn')">Efternamn</a></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('Personnr')">Personnr</a></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('Kon')">Kön</a></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('AnstDatum')">Anst. Datum</a></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('YrkeDatum')">Yrke datum</a></th>
                                <th class="col"><a href="javascript:void(0)" @click="getEmployeesFromCompany('Befattningsnamn')">Befattning</a></th>
                                <th class="col" v-if="analysisCriterias1.length > 1"><a href="javascript:void(0)" @click="getEmployeesFromCompany('Analyskriterie1')">{{analysisCriteria1Name}}</a></th>
                                <th class="col" v-if="analysisCriterias2.length > 1"><a href="javascript:void(0)" @click="getEmployeesFromCompany('Analyskriterie2')">{{analysisCriteria2Name}}</a></th>
                                <th class="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in employees" :key="index">
                                <td>
                                    <v-checkbox density="compact" v-model="item.delete" hide-details></v-checkbox>
                                </td>
                                <td valign="middle">
                                    <span>{{item.EmployeeNumber}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{item.FirstName}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{item.LastName}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{item.SocialSecurityNumber}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{item.Sex}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{getDateStr(item.EmploymentDate)}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{getDateStr(item.OccupationStartDate)}}</span>
                                </td>
                                <td valign="middle">
                                    <span>{{item.PositionName}}</span>
                                </td>
                                <td valign="middle" v-if="analysisCriterias1.length > 1">
                                    <span><nobr>{{item.AnalysisCriteria1}}</nobr></span>
                                </td>
                                <td valign="middle" v-if="analysisCriterias2.length > 1">
                                    <span><nobr>{{item.AnalysisCriteria2}}</nobr></span>
                                </td>
                                <td valign="middle">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateEmployee(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteEmployee(item.EmployeeId)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <div class="row">
                <div class="col">

                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="deleteEmployees">
                        Ta bort markerade
                    </v-btn>

                </div>

            </div>
            <div class="row" style="margin-top:30px !important;">
                <div class="col">

                    <CommonLabelContainer title="Uppdatera analyskriterium">

                        <div class="container-fluid p-0 px-3">
                            <div class="row mt-1">
                                <div class="col">
                                    Här kan man uppdatera analyskriterium för samtliga anställda som inte redan blivit tilldelade ett kriterium.<br />
                                    Anställda som redan har ett kriterium påverkas inte.
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col col-md-6">
                                    <div v-if="analysisCriterias1.length > 1">
                                        <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" v-bind:label="analysisCriteria1Name" :items="analysisCriterias1" v-model="analysisCriteria1"></v-select>
                                    </div>

                                    <div v-if="analysisCriterias2.length > 1">
                                        <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" v-bind:label="analysisCriteria2Name" :items="analysisCriterias2" v-model="analysisCriteria2"></v-select>
                                    </div>

                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="updateEmployeeAnalysisCriteria">
                                        Uppdatera
                                    </v-btn>
                                </div>
                            </div>
                        </div>

                    </CommonLabelContainer>


                </div>
            </div>
        </div>
        <WageUpdateEmployee v-bind:disabled="disabled" :model="model" ref="updateEmployeeDialogue" @updated="load"></WageUpdateEmployee>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import AdminService from "../../Services/AdminService";
    import ValidationService from "../../Services/ValidationService";
    import { getCurrentInstance } from 'vue'
    import WageUpdateEmployee from './update/update-employee.vue'
    import CommonLabelContainer from "../../common/common-label-container";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'

    const updateEmployeeDialogue = ref(null);
    const adduserform = ref(null);

    export default {
        name: 'wage-emploee-admin',
        components: {
            WageUpdateEmployee,
            CommonLabelContainer,
            CommonSpinner,
        },
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async getEmployeesFromPosition(position) {
                this.loading++;
                try {
                    this.employees = await WageService.getEmployeesFromJobPosition(position);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getDateStr(date){
                if(!date || date == null || date == "")
                    return "";
                return new Date(date).toISOString().split('T')[0];
            },
            async getEmployeeAnalysisCriteria() {
                this.loading++;
                try {
                    var analysisCriterias = await AdminService.getAnalysisCriterias();
                    if (analysisCriterias.Criteria1.Active == true) {
                        this.analysisCriterias1 = analysisCriterias.Criteria1.ContentStrings;
                        this.analysisCriteria1Name = analysisCriterias.Criteria1.Name;
                    }

                    if (analysisCriterias.Criteria2.Active == true) {
                        this.analysisCriterias2 = analysisCriterias.Criteria2.ContentStrings;
                        this.analysisCriteria2Name = analysisCriterias.Criteria2.Name;
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateEmployeeAnalysisCriteria() {
                this.loading++;
                var thisContext = this;
                try {
                    await WageService.updateEmployeeAnalysisCriteria(this.analysisCriteria1, this.analysisCriteria2);
                    thisContext.displaySnackBar("Sparat");
                    thisContext.employees = await WageService.getEmployeesFromCompany();
                }
                catch (error) {
                    thisContext.displayErrorSnackBar("Var god kontrollera analyskriterium")
                }
                this.loading--;
            },
            async getEmployeesFromCompany(sort) {
                this.loading++;
                try {
                    this.employees = await WageService.getEmployeesFromCompany(sort);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async addEmployee() {
                var thisContext = this;
                this.adduserform.validate().then(async ({ valid: isValid }) => {
                    thisContext.loading++;
                    try {
                        if (isValid == true) {
                            try {
                                await WageService.addEmployee(thisContext.employeeNumber, thisContext.firstName, thisContext.lastName, thisContext.socialSecurityNumber, thisContext.sex, thisContext.employeeStartDate, thisContext.occupationStartDate, thisContext.analysisCriteria1, thisContext.analysisCriteria2, thisContext.selectedPosition);
                                thisContext.displaySnackBar("Sparat");
                            }
                            catch (error) {
                                thisContext.displayErrorSnackBar("Ett oväntat fel har inträffat")
                            }
                            thisContext.getEmployeesFromCompany();
                            thisContext.clear();
                        }
                    }
                    catch (error) {
                        thisContext.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                    }
                    thisContext.loading--;
                });
            },
            updateEmployee(item) {
                this.loading++;
                this.updateEmployeeDialogue.open(item);
                this.loading--;
            },
            async deleteEmployee(employeeId) {
                if (confirm("Är du säker på att du vill radera den anställde?")) {
                    this.loading++;
                    try {
                        await WageService.deleteEmployee(employeeId);
                        this.displaySnackBar("Den anställda togs bort");
                        this.getEmployeesFromCompany();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async deleteEmployees() {
                if (confirm("Är du säker på att du vill radera de valda anställda?")) {
                    this.loading++;
                    try {
                        var employeesToDelete = [];
                        for (var i = 0; i < this.employees.length; i++) {
                            if (this.employees[i].delete == true) {
                                employeesToDelete.push(this.employees[i]);
                            }
                        }
                        try {
                            await WageService.deleteEmployees(employeesToDelete);
                            this.displaySnackBar("De anställda är borttagna");
                        }
                        catch (error) {
                            this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                        }
                        this.getEmployeesFromCompany();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                    }
                    this.loading--;
                }
            },
            load() {
                this.loading++;
                try {
                    this.getEmployeesFromCompany();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            clear() {
                this.employeeNumber = null;
                this.firstName = null;
                this.lastName = null;
                this.socialSecurityNumber = null;
                this.employeeStartDate = null;
                this.occupationStartDate = null;
                this.analysisCriteria1 = null;
                this.analysisCriteria1Name = null;
                this.analysisCriteria2 = null;
                this.analysisCriteria2Name = null;
                this.selectedPosition = null;
                this.sex = "";
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                valid: false,
                sexes: [{ name: "Odefinierat", value: "" }, { name: "Man", value: "Man" }, { name: "Kvinna", value: "Kvinna"}],
                rules: ValidationService.rules(),
                occupationStartDate:null,
                employeeStartDate:null,
                firstName: null,
                lastName:null,
                employeeNumber:null,
                socialSecurityNumber:null,
                employees: [],
                selectedPosition: null,
                analysisCriteria1: null,
                analysisCriterias1: [],
                analysisCriteria1Name: null,
                analysisCriteria2: null,
                analysisCriteria2Name: null,
                analysisCriterias2: [],
                sex:"",
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            //selectedPosition: function () {
                //this.loadEmployees(newVal);
            //},
        },
        mounted() {
            this.internalModel = this.model;
            this.getEmployeeAnalysisCriteria();
            this.load();
        },

        setup() {
            return { updateEmployeeDialogue, adduserform }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
